import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Stack } from "@mui/material";
import { useBorder } from "@pulse/shared-components";
import {
  useCornerRadius,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { GripVertical } from "lucide-react";
import React, { PropsWithChildren } from "react";

interface SurveyRuleCardLayoutProps extends PropsWithChildren {
  surveyRuleId: string;
}

const DND_BUTTON_SIZE = "48px";
const IS_DRAGGING_OPACITY = 0.35;

export const SurveyRuleCardLayout: React.FC<SurveyRuleCardLayoutProps> = ({
  surveyRuleId,
  children,
}) => {
  const border = useBorder();
  const cornerRadius = useCornerRadius();
  const spacing = useSpacing();
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: surveyRuleId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Stack direction="row" gap={spacing.spaceXS} ref={setNodeRef} style={style}>
      <Stack
        justifyContent="center"
        alignItems="center"
        {...attributes}
        {...listeners}
        style={{
          cursor: isDragging ? "grabbing" : "grab",
          height: DND_BUTTON_SIZE,
          width: DND_BUTTON_SIZE,
        }}
      >
        <GripVertical />
      </Stack>
      <Stack
        width="100%"
        border={isDragging ? border.primaryDashed : undefined}
        borderRadius={isDragging ? cornerRadius.radiusXS : undefined}
        boxSizing="border-box"
        sx={{
          opacity: isDragging ? IS_DRAGGING_OPACITY : 1,
          pointerEvents: isDragging ? "none" : undefined,
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};
